import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_CONFIG from '../config/api';
const TransactionStatus = ({ transaction }) => {
  const [status, setStatus] = useState('pending');
  const [details, setDetails] = useState(null);

  useEffect(() => {
    if (transaction?.txHash) {
      checkTransactionStatus();
      const interval = setInterval(checkTransactionStatus, 10000); // Check every 10 seconds
      
      return () => clearInterval(interval);
    }
  }, [transaction]);

  const checkTransactionStatus = async () => {
    try {
      const response = await axios.get(
        `${API_CONFIG.BASE_URL}/api/tx/${transaction.txHash}/${transaction.fromChain}`
      );
      
      setStatus(response.data.status);
      setDetails(response.data);
    } catch (error) {
      console.error('Failed to check transaction status:', error);
    }
  };

  const getStatusIcon = () => {
    switch (status) {
      case 'pending':
        return '⏳';
      case 'success':
        return '✅';
      case 'failed':
        return '❌';
      default:
        return '⏳';
    }
  };

  const getStatusText = () => {
    switch (status) {
      case 'pending':
        return 'Transaction Pending';
      case 'success':
        return 'Transaction Successful';
      case 'failed':
        return 'Transaction Failed';
      default:
        return 'Unknown Status';
    }
  };

  const getStatusColor = () => {
    switch (status) {
      case 'pending':
        return '#f59e0b';
      case 'success':
        return '#10b981';
      case 'failed':
        return '#ef4444';
      default:
        return '#6b7280';
    }
  };

  if (!transaction) return null;

  return (
    <div className="transaction-status">
      <h3>Transaction Status</h3>
      
      <div className="status-header">
        <span className="status-icon">{getStatusIcon()}</span>
        <span className="status-text" style={{ color: getStatusColor() }}>
          {getStatusText()}
        </span>
      </div>

      <div className="transaction-details">
        <div className="detail-item">
          <span>Transaction Hash:</span>
          <a 
            href={transaction.explorer} 
            target="_blank" 
            rel="noopener noreferrer"
            className="tx-hash"
          >
            {transaction.txHash.slice(0, 10)}...{transaction.txHash.slice(-8)}
          </a>
        </div>
        
        <div className="detail-item">
          <span>From Chain:</span>
          <span>{transaction.fromChain}</span>
        </div>
        
        <div className="detail-item">
          <span>To Chain:</span>
          <span>{transaction.toChain}</span>
        </div>
        
        <div className="detail-item">
          <span>Amount:</span>
          <span>{transaction.amount} tokens</span>
        </div>

        {details && details.blockNumber && (
          <div className="detail-item">
            <span>Block Number:</span>
            <span>{details.blockNumber}</span>
          </div>
        )}

        {details && details.gasUsed && (
          <div className="detail-item">
            <span>Gas Used:</span>
            <span>{details.gasUsed}</span>
          </div>
        )}
      </div>

      <div className="progress-indicator">
        <div className="progress-step completed">
          <div className="step-circle">1</div>
          <span>Transaction Submitted</span>
        </div>
        
        <div className={`progress-step ${status !== 'pending' ? 'completed' : ''}`}>
          <div className="step-circle">2</div>
          <span>Source Chain Confirmed</span>
        </div>
        
        <div className="progress-step">
          <div className="step-circle">3</div>
          <span>LayerZero Processing</span>
        </div>
        
        <div className="progress-step">
          <div className="step-circle">4</div>
          <span>Destination Chain Delivery</span>
        </div>
      </div>

      {status === 'pending' && (
        <div className="pending-message">
          <p>Your transaction is being processed. This may take a few minutes.</p>
        </div>
      )}

      {status === 'success' && (
        <div className="success-message">
          <p>🎉 Your cross-chain transfer has been completed successfully!</p>
        </div>
      )}

      {status === 'failed' && (
        <div className="error-message">
          <p>❌ Your transaction failed. Please try again or contact support.</p>
        </div>
      )}
    </div>
  );
};

export default TransactionStatus;